import './product-card.style.scss'



import { useContext } from 'react';
import { selectCartItems } from '../../store/cart/cart.selector';
// import { CartContext } from '../../contexts/cart.context';
import { useDispatch,useSelector } from 'react-redux';
import { addItemtoCart } from '../../store/cart/cart.action';
import Button,{Button_Type_Classes} from '../button/button.component';

const ProductCard=({product})=>{
    const {name,price,imageUrl}=product;
    
    const dispatch= useDispatch()
    const cartItems =useSelector(selectCartItems)
    const addProductToCart=()=>dispatch(addItemtoCart(cartItems,product))
    
    return (
    <div className='product-card-container'>
        <img src={imageUrl} alt={`${name}`}/>
        <div className='footer'>
            <span className='name'>{name}</span>
            <span className='price'>{price}</span>

        </div>
        <Button buttonType={Button_Type_Classes.inverted} onClick={addProductToCart}>Add to Cart</Button>

    </div>
)
}
export default ProductCard;